<template>
  <div>
    <video-modal
      v-if="video"
      :content-id="video.id"
      :video-id="video.vimeoId"
      :tag="video.tag"
      :sector="video.sector"
      :title="video.title"
      :description="video.description"
      @close-modal="handleCloseModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import VideoModal from '../../components/modals/VideoModal.vue';

export default {
  components: {
    VideoModal,
  },
  computed: {
    ...mapGetters(['currentVideo', 'videos']),
  },
  watch: {
    currentVideo() {
      this.video = this.currentVideo;
    },
    videos() {
      if (!this.currentVideo) {
        this.handleGetCurrentVideoFromId()
      }
    },
  },
  data: () => ({
    video: null,
  }),
  mounted() {
    if (this.currentVideo) {
      this.video = this.currentVideo;
    } else {
      this.handleGetCurrentVideoFromId();
    }
  },
  destroyed() {
    //
  },
  methods: {
    ...mapActions(['setCurrentVideo']),
    async handleGetCurrentVideoFromId() {
      if (this.videos && this.videos.length) {
        const id = this.$route.params.id;
        const currentVideo = this.videos.find(video => Number(video.id) === Number(id));
        if (currentVideo && currentVideo.url) {
          const vimeoId = await axios
            .get(`https://vimeo.com/api/oembed.json?url=${currentVideo.url}`)
            .then(response => {
              const { data } = response;
              return data.video_id;
            })
          this.setCurrentVideo({
            ...currentVideo,
            vimeoId,
          })
          return;
        }
        this.$router.push({ name: 'Home', query: { video: -1 } })
      }
    },
    handleCloseModal() {
      this.setCurrentVideo(null);
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>
